export default __webpack_public_path__ + "static/media/pinduoduo2.1c4431e1.jpg";